// extracted by mini-css-extract-plugin
export default {"reviewsContainer":"AppReviews-module__reviewsContainer__unnj1","reviewItem":"AppReviews-module__reviewItem__aef4J","rating":"AppReviews-module__rating__HBSbz"};